import { hasPermission } from '@/app/store/auth'
import type { User } from '@/types/entities'

/**
 * `ticker.view`, read the way the rest of the client reads a permission: from the /auth/me user's
 * roles (hasPermission), never from the login-shaped user the auth store may briefly hold, which
 * carries no permissions at all (see useTemplateAccess). The catalogue names it `ticker.view`
 * with resource `ticker` and action `view`; either spelling is accepted.
 *
 * Its own module so the ticker store can read it without importing the hooks.
 */
export function userCanViewTicker(user: User | null | undefined): boolean {
    if (!user) return false
    if (hasPermission(user, 'ticker', 'view')) return true
    return (user.roles ?? []).some(
        (role) => typeof role === 'object' && role !== null && (role.permissions ?? []).some((p) => p?.name === 'ticker.view'),
    )
}
